import { render, staticRenderFns } from "./PromotionsCreate.vue?vue&type=template&id=787c6ea8&scoped=true"
import script from "./PromotionsCreate.vue?vue&type=script&lang=ts"
export * from "./PromotionsCreate.vue?vue&type=script&lang=ts"
import style0 from "./PromotionsCreate.vue?vue&type=style&index=0&id=787c6ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787c6ea8",
  null
  
)

export default component.exports